import { CwtApiSchema, CwtProp, CwtSchema } from "@cawita/core-front/api";

export enum CustomFieldSetTimerCondition {
    Before = 'before',
    After = 'after'
}

@CwtSchema()
export class CustomFieldSetTimer extends CwtApiSchema {
    @CwtProp() condition: CustomFieldSetTimerCondition;
    @CwtProp() value: number;
}